// removed by extract-text-webpack-plugin
module.exports = {"IconRejectStatusCell":"IconRejectStatusCell","ErrorIcon":"ErrorIcon","IconRejectStatusTooltip":"IconRejectStatusTooltip","tooltip-inner":"tooltip-inner"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/GridCustomCell/IconRejectStatusCell/styles.scss
// module id = 2113
// module chunks = 10